import { render, staticRenderFns } from "./ChuKuGBRecord.vue?vue&type=template&id=ac92dba0&"
import script from "./ChuKuGBRecord.vue?vue&type=script&lang=js&"
export * from "./ChuKuGBRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports